import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
import AuthMenuPointList from "./menu-point-list.vue";
export default {
  name: "auth-menu-point-line",
  components: {
    AuthMenuPointList
  },
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Object,
      default: () => {
        return {};
      }
    },
    valueProperty: {
      type: String,
      default: 'individual_value'
    }
  },
  computed: {
    individual: function () {
      return this.valueProperty === 'individual_value';
    },
    fantomChecker: function () {
      return this.individual && this.modelValue.role_group_value;
    },
    show: function () {
      return this.individualValue || this.fantomChecker;
    }
  },
  data: function () {
    return {
      individualValue: false
    };
  },
  methods: {
    setMenuPointRoles: function (model) {
      if (model[this.valueProperty] === false) {
        if (model.role_category?.crud_roles?.length) {
          model.role_category.crud_roles = model.role_category.crud_roles.map(r => {
            r[this.valueProperty] = false;
            return r;
          });
        }
        if (model.role_category?.basic_roles?.length) {
          model.role_category.basic_roles = model.role_category.basic_roles.map(r => {
            r[this.valueProperty] = false;
            return r;
          });
        }
      }
    },
    setSubMenuPoint: function (menuPoint) {
      menuPoint[this.valueProperty] = false;
      this.setMenuPointRoles(menuPoint);
      menuPoint.menu_points.forEach(mp => {
        this.setSubMenuPoint(mp);
      });
    },
    hasIndividualMenuPoint: function (mp) {
      return mp.menu_points.some(m => m.individual_value === true || this.hasIndividualMenuPoint(m));
    },
    setIndividualValue: function (event) {
      const obj = {};
      obj[this.valueProperty] = event.target.checked;
      const model = Object.assign({}, this.modelValue, obj);
      if (obj[this.valueProperty] === false) {
        this.setSubMenuPoint(model);
      }
      if (this.individual && !model[this.valueProperty] && this.hasIndividualMenuPoint(model)) {
        model[this.valueProperty] = true;
      }
      this.$emit('update:modelValue', model);
    },
    setRoleIndividualValue: function (value, key, roleType) {
      const model = JSON.parse(JSON.stringify(this.modelValue));
      model.role_category[roleType][key][this.valueProperty] = value;
      this.$emit('update:modelValue', model);
    },
    updateModelValue: function (value) {
      const model = JSON.parse(JSON.stringify(this.modelValue));
      model.menu_points = value;
      if (this.individual && !model[this.valueProperty] && this.hasIndividualMenuPoint(model)) {
        model[this.valueProperty] = true;
      }
      console.log(this.individual, !model[this.valueProperty], this.hasIndividualMenuPoint(model), model);
      this.$emit('update:modelValue', model);
    }
  },
  watch: {
    modelValue: {
      deep: true,
      immediate: true,
      handler: function (value) {
        if (value?.[this.valueProperty] !== this.individualValue) {
          this.individualValue = value[this.valueProperty];
        }
      }
    }
  }
};